import { Component, OnInit, Input } from "@angular/core";
import { FilterPipe } from "ngx-filter-pipe";

@Component({
  selector: "app-faq",
  templateUrl: "./faq.component.html",
  styleUrls: ["./faq.component.scss"]
})
export class FaqComponent implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))

  userFilter1: any = { topic: "" };

  constructor(private filterPipe: FilterPipe) {}

  aria: boolean;

  @Input()
  value: string;

  title: any[] = [
    {
      id: "faq1",
      topic: this.language.faq1,
      detail: [
        {
          name: this.language.faq1detail
        }
      ]
    },
    {
      id: "faq2",
      topic: this.language.faq2,
      detail: [
        {
          name:
            this.language.faq2detail+'<a href="https://onelive.one-asset.com/Home" target="_blank"> https://onelive.one-asset.com/Home </a> '
        },
        {
          name: this.language.faq2line1
        },
        {
          name: this.language.faq2line2
        },
        {
          name: this.language.faq2line3
        },
        {
          name: this.language.faq2line4
        },
        {
          name:
            this.language.faq2line4list1
        },
        {
          name:
            this.language.faq2line4list2
        },
        {
          name:
            this.language.faq2line4list3
        }
      ]
    },
    {
      id: "faq3",
      topic: this.language.faq3,
      detail: [
        {
          name:
            this.language.faq3detail
        },
        {
          name:
            this.language.faq3line1
        },
        {
          name:
            this.language.faq3line2
        }
      ]
    },
    {
      id: "faq4",
      topic: this.language.faq4,
      detail: [
        {
          name:
            this.language.faq4detail
        }
      ]
    },
    {
      id: "faq5",
      topic: this.language.faq5,
      detail: [
        {
          name: this.language.faq5detailline1
        },
        {
          name: this.language.faq5detailline2
        },
        {
          name: this.language.faq5detailtitle
        },
        {
          name: this.language.faq5list1
        },
        {
          name: this.language.faq5list2
        },
        {
          name: this.language.faq5list2line1
        },
        {
          name: this.language.faq5list2line2
        }
      ]
    },

    {
      id: "faq6",
      topic: this.language.faq6,
      detail: [
        {
          name:this.language.faq6detailline1
        },
        {
          name:this.language.faq6detailline2
        }
      ]
    },
    {
      id: "faq7",
      topic: this.language.faq7,
      detail: [
        {
          name: this.language.faq7detailline1
        },
        {
          name: this.language.faq7detailline2
        }
      ]
    },
    {
      id: "faq8",
      topic: this.language.faq8 ,
      detail: [
        {
          name: this.language.faq8detailline1
        },
        {
          name: this.language.faq8detailtitle
        },
        {
          name: this.language.faq8list2line1
        },
        {
          name: this.language.faq8list2line2
        }
      ]
    }
  ];

  ngOnInit() {}

  isCollapse: boolean;
  currentSection: any;
  defaultTitle = this.language.searchonly;

  onSectionChange(sectionId: string, group) {
    this.currentSection = sectionId;
    this.value = group.title;
  }

  scrollTo(section) {
    document
      .querySelector("#" + section)
      .scrollIntoView({ behavior: "smooth"});
  }
}
